import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Trackers } from '@models/partner/trackers';

@Injectable({
  providedIn: 'root',
})
export class TrackersWebService {
  readonly #http = inject(HttpClient);

  get(partnerId: string): Observable<Trackers> {
    return this.#http.get<Trackers>(
      `${environment.api.obendy}/v1/partner-revision/${partnerId}/trackers-configuration`
    );
  }

  put(partnerId: string, trackers: Trackers): Observable<void> {
    return this.#http.put<undefined>(
      `${environment.api.obendy}/v1/partner-revision/${partnerId}/trackers-configuration`,
      trackers
    );
  }
}
